import { render, staticRenderFns } from "./yuyveDiscuss.vue?vue&type=template&id=650e995b&"
import script from "./yuyveDiscuss.vue?vue&type=script&lang=ts&"
export * from "./yuyveDiscuss.vue?vue&type=script&lang=ts&"
import style0 from "./yuyveDiscuss.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports